import type { GiftcardAddon, GiftcardCartItem } from '~/composables/types/cart'
import type { Pricings } from '~/composables/types/event'

// The cart thumbnail reflects how the giftcard is delivered: a physical box,
// a greeting card (envelope), or a plain PDF.
const giftcardThumbnail = (giftcardAddon: GiftcardAddon): string => {
  if (giftcardAddon === 'BOX')
    return '/_nuxt3-static/giftcard/giftcard-giftbox-preview.png'
  if (giftcardAddon === 'CARD_BOX')
    return '/_nuxt3-static/giftcard/giftcard-giftbox-preview.png'
  if (giftcardAddon === 'CARD') return '/_nuxt3-static/giftcard/envelope.png'

  return '/_nuxt3-static/giftcard/giftcard-pdf.png'
}

const parseGiftcardWithoutEvent = (
  pricings: Pricings,
  name: string,
  supplierId: string | undefined | null,
  id?: string,
  supplierName?: string,
  giftcardAddon: GiftcardAddon = 'PDF'
): GiftcardCartItem => {
  return {
    type: 'GIFT_CARD',
    giftcardType: 'VALUE',
    giftcardAddon,
    title: name || 'Giftcard',
    pricings,
    thumbnail: giftcardThumbnail(giftcardAddon),
    quantity: 1,
    giftcardId: id || 'giftcard',
    ...(supplierId && { supplierId }),
    supplier: supplierName,
  }
}

export default parseGiftcardWithoutEvent
